<template>
	<div class="page-clerkminutes-unlock">
		<div class="card">
			<div class="card-body">
				<div class="mt-5 mx-3">
					<h2 class="display-3 text-center text-balance mb-5">
						Create Meeting Minutes, in Minutes!
					</h2>

					<p v-if="j.used_clerkminutes" class="lead text-center mb-5">
						<a href="https://clerkminutes.com/" target="clerkminutes">Learn more</a> about how ClerkMinutes
						works.
					</p>

					<div v-else class="row align-items-center mb-6">
						<div class="col-lg-6">
							<p class="lead">
								Ditch manual transcribing. Embrace automation. Boost productivity by 10x in just 10
								minutes.
							</p>
							<p class="lead">
								<a href="https://clerkminutes.com/" target="clerkminutes">Learn more</a> about how
								ClerkMinutes works.
							</p>
						</div>
						<div class="col">
							<img
								src="https://edge.heygov.com/illustrations/clerkminutes.webp"
								alt="ClerkMinutes"
								class="img-fluid"
							/>
						</div>
					</div>

					<stripe-pricing-table
						v-if="stripeCustomerReference"
						pricing-table-id="prctbl_1RBFAiLn2cdp6hSMbadlQxXi"
						:publishable-key="stripePublishableKey"
						:customer-session-client-secret="stripeCustomerReference"
					>
					</stripe-pricing-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import { hgApi } from '@/api.js'

export default {
	data() {
		return {
			stripeCustomerReference: null,
		}
	},
	computed: {
		...mapState(['j', 'stripePublishableKey']),
	},
	created() {
		hgApi(`/${this.j.slug}/billing/customer-session`, { method: 'POST' })
			.then(response => response.json())
			.then(data => {
				this.stripeCustomerReference = data
			})
	},
	mounted() {
		let stripePricingScript = document.createElement('script')
		stripePricingScript.setAttribute('src', 'https://js.stripe.com/v3/pricing-table.js')
		document.head.appendChild(stripePricingScript)
	},
}
</script>
